module.exports = "query GetItem($id: ID!) {\n  item(id: $id) {\n    ...ItemFragment\n  }\n}\n"